import { useQuery } from '@tanstack/react-query';
import { fetchSmriqDurationDefaults } from '../services/smriqPlanConfig';

export const smriqDurationDefaultsKey = ['smr', 'smriq', 'duration-defaults'] as const;

/** Platform duration bounds — env config, stable for the session. */
export const useSmriqDurationDefaults = () =>
    useQuery({
        queryKey: smriqDurationDefaultsKey,
        queryFn: fetchSmriqDurationDefaults,
        staleTime: Infinity,
    });
